import React from 'react';
import PaginationBase from '../../../common/base/PaginationBase';
import { message } from 'antd';

import {
    VENTA_GUIA_REMISION_GENERA_SALIDAS,
    CONTROL_COMPBANTE
} from '../../../common/types/parametroType';
import {
    VENTAS_COTIZACION
} from "../../../common/types/referenciaOrigenType";
import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { FACTURA, OTROS, GUIA_REMISION_REMITENTE } from '../../../common/types/tipoComprobanteType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';
import { SERVICIO } from '../../../common/types/tipoProductoType';
import { PRIVADO } from '../../../common/types/modalidadTrasladoType';
import { LOGISTICA } from '../../../common/types/sistemaType'
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import auth from '../../../common/utility/auth';
import printFormatMock from '../../../common/mock/printFormatMock';

import establecimientoService from '../../../service/administracion/establecimientoService';
import almacenService from '../../../service/administracion/almacenService';
import padronReducidoService from '../../../service/integracion/padronReducidoService';
import proveedorService from '../../../service/administracion/proveedorService';
import tipoComprobanteService from '../../../service/administracion/tipoComprobanteService';
import productoService from '../../../service/administracion/productoService';
import proyectoService from '../../../service/administracion/proyectoService';
//import detraccionService from '../../../service/administracion/detraccionService';
//import ordenCompraService from '../../../service/logistica/ordenCompraService';
//import conceptoService from '../../../service/logistica/conceptoService';
//import movimientoService from '../../../service/logistica/movimientoService';
import vehiculoService from '../../../service/logistica/vehiculoService';
import choferService from '../../../service/logistica/choferService';
import modalidadTrasladoService from '../../../service/logistica/modalidadTrasladoService';
import transporteService from '../../../service/logistica/transporteService';
import motivoTrasladoService from '../../../service/logistica/motivoTrasladoService';
import guiaRemisionService from '../../../service/logistica/guiaRemisionService';
import ubigeoService from '../../../service/integracion/ubigeoService';
import comprobanteService from '../../../service/ventas/comprobanteService';
import clienteService from '../../../service/administracion/clienteService';
import unidadMedidaService from '../../../service/administracion/unidadMedidaService';
import guiaService from '../../../service/logistica/guiaService';
import cotizacionService from "../../../service/ventas/cotizacionService";
import configuracionService from '../../../service/seguridad/usuarioConfiguracionService';


import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';
import ImportarModal from './ImportarModal';
import FormModalVer from './FormModalVer';
import SearchProductModal from './SearchProductModal';
import FormModalImportarComprobante from './FormModalImportarComprobante'
import RenombrarProductoModal from './RenombrarProductoModal';
import ImprimirModal from './ImprimirModal';
import EmitirModal from './EmitirModal';
import CdrModal from './CdrModal';
import CorreoModal from './CorreoModal';
import ImportarModalCotizacion from "./ImportarModalCotizacion";


import { VENTA } from '../../../common/types/moduloType';
import { VER_SERIES_VENTA, EMI_GUIA_AUTO, EDIT_COD_GUIA } from '../../../common/types/configuracionType';



var formValuesComprobante = {
    listaComprobanteDetalle: [],
    listaComprobanteReferencia: [],
    productos: [],
    idComprobante: 0
}

var referenciaCount = 1;

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();

        this.state = {
            loadingSource: true,
            loadingCopy: false,

            listasPrecio: [],
            sucursales: [],
            vendedores: [],
            almacenes: [],
            clientes: [],
            tiposGuia: [],
            traslados: [],
            motivos: [],
            vehiculos: [],
            choferes: [],
            etransportes: [],
            direccionesPartidas: [],
            tiposComprobante: [],
            productos: [],
            proyectos: [],
            configuraciones: [],
            company: {},
            estado: [],
            departamentosPartida: [],
            provinciasPartida: [],
            distritosPartida: [],
            proveedores: [],
            unidadesMedida: [],
            departamentosLlegada: [],
            provinciasLlegada: [],
            distritosLlegada: [],
            correoVisible: false,
            comprobantes: [],
            totaldocument: [],
            cdrVisible: false,
            selectedItem: {},
            filter: {
                cliente: "",
                idMotivo: 0,
                idTipoComprobante: FACTURA.ID,
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                serie: '',
                documento: '',
                idEstado: 0,
                idTraslado: 0,
                idProyecto: 0,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            productoVisible: false,
            importarOCVisible: false,
            visibleVer: false,
            loadingImprimir: false,
            loadingCorreo: false,
            renombrarProductoVisible: false,
            importarComprobanteModalVisible: false,
            formValues: this.fetchEmptyFormValues(),
            onSetFieldsValue: null,
            onGetFieldValue: null,
            searchProductVisible: false,
            importarCotizacionVisible: false,
            searchProductFormValues: {
                validarStock: false,
                dataSource: []
            },
            importarCotizacionFormValues: {
                nombre: "",
                dataSource: [],
                selectedRowKeys: [],
            },
            productoModal: {
                nombre: '',
                dataSource: [],
                selectedRowKeys: []
            },
            renombrarProductoModal: {
                nombre: '',
                idProducto: 0,
                identifier: '',
                flagEditCode: false
            },
            importarComprobanteModal: {
                nombre: '',
                dataSource: []
            },
            imprimirFormValues: {
                file: undefined,
                idGuiaRemision: 0,
                idFormato: 0,
                isEpson: false,
                formatos: printFormatMock.values
            },

            importarComprobanteVisible: false,
            importarFormValues: {
                nombre: "",
                dataSource: [],
                selectedRowKeys: [],
            },
            correoFormValues: {
                file: undefined,
                idComprobante: 0,
                idFormato: 0,
                correoCliente: '',
                formatos: printFormatMock.values
            },
            onSetFieldsValue: null,
            onGetFieldValue: null,
            ubigeos: [],
            prodsArrDetalle: []
        }
    }

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleClearFilters = () => {
        var filter = {
            cliente: "",
            idMotivo: 0,
            idTipoComprobante: FACTURA.ID,
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            serie: '',
            documento: '',
            idEstado: 0,
            idTraslado: 0,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleChangeForm = async (property, value, form) => {

        if (property === "idCliente" && value != undefined) {

            const direcciones = await establecimientoService.listarPorIdEntidad(value);
            const direccionPrincipal = direcciones.length > 0 ? direcciones[0] : undefined;
            const provinciasLlegada = await ubigeoService.provincias(direccionPrincipal.idDepartamento);
            const distritosllegada = await ubigeoService.distritos(direccionPrincipal.idProvincia);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provinciasLlegada: provinciasLlegada ? provinciasLlegada : [],
                    distritosLlegada: distritosllegada ? distritosllegada : [],
                    idEstablecimientoDestino: direccionPrincipal.id,
                }
            }, () => {

                form.setFieldsValue({
                    direccionLlegada: direccionPrincipal.direccion,
                    idEstablecimientoDestino: direccionPrincipal.id,
                    idDepartamentoLlegada: direccionPrincipal.idDepartamento > 0 ? { key: direccionPrincipal.idDepartamento } : undefined,
                    idProvinciaLlegada: direccionPrincipal.idProvincia > 0 ? { key: direccionPrincipal.idProvincia } : undefined,
                    idDistritoLlegada: direccionPrincipal.idUbigeo > 0 ? { key: direccionPrincipal.idUbigeo } : undefined,
                });
            });
        }

        if (property === "idTercero") {

            const direcciones = await establecimientoService.listarPorIdEntidad(value);
            const direccionPrincipal = direcciones.length > 0 ? direcciones[0] : undefined;
            const provinciasLlegada = await ubigeoService.provincias(direccionPrincipal.idDepartamento);
            const distritosllegada = await ubigeoService.distritos(direccionPrincipal.idProvincia);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direccionesPartidas: direcciones,
                    provinciasPartida: provinciasLlegada ? provinciasLlegada : [],
                    distritosPartida: distritosllegada ? distritosllegada : [],
                    idEstablecimientoPartida: direccionPrincipal.id,
                }
            }, () => {

                form.setFieldsValue({
                    direccionPartida: direccionPrincipal.direccion,
                    idEstablecimientoPartida: { key: direccionPrincipal.id },
                    idDepartamentoPartida: direccionPrincipal.idDepartamento > 0 ? { key: direccionPrincipal.idDepartamento } : undefined,
                    idProvinciaPartida: direccionPrincipal.idProvincia > 0 ? { key: direccionPrincipal.idProvincia } : undefined,
                    idDistritoPartida: direccionPrincipal.idUbigeo > 0 ? { key: direccionPrincipal.idUbigeo } : undefined,
                });
            });
        }


        if (property === "idProveedor") {
            const direcciones = await establecimientoService.listarPorIdEntidad(value);
            const direccionPrincipal = direcciones.length > 0 ? direcciones[0] : undefined;
            const provinciasPartida = await ubigeoService.provincias(direccionPrincipal.idDepartamento);
            const distritosPartida = await ubigeoService.distritos(direccionPrincipal.idProvincia);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provinciasPartida: provinciasPartida ? provinciasPartida : [],
                    distritosPartida: distritosPartida ? distritosPartida : [],
                    idEstablecimientoPartida: direccionPrincipal.id,
                    direccionesPartidas: direcciones,
                    direccionPartida: direccionPrincipal.direccion,


                }
            }, () => {

                form.setFieldsValue({
                    direccionPartida: direccionPrincipal.direccion,
                    idEstablecimientoPartida: { key: direccionPrincipal.id === 0 ? undefined : direccionPrincipal.id },
                    idDepartamentoPartida: direccionPrincipal.idDepartamento > 0 ? { key: direccionPrincipal.idDepartamento } : undefined,
                    idProvinciaPartida: direccionPrincipal.idProvincia > 0 ? { key: direccionPrincipal.idProvincia } : undefined,
                    idDistritoPartida: direccionPrincipal.idUbigeo > 0 ? { key: direccionPrincipal.idUbigeo } : undefined,
                });
            });

            this.handleOnChangeEntidad(form)
        }

        if (property === "idEstablecimientoPartida") {

            const direccion = await establecimientoService.obtenerPorId(value);
            const provinciasPartida = await ubigeoService.provincias(direccion.idDepartamento);
            const distritosPartida = await ubigeoService.distritos(direccion.idProvincia);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provinciasPartida: provinciasPartida ? provinciasPartida : [],
                    distritosPartida: distritosPartida ? distritosPartida : [],
                }
            }, () => {

                form.setFieldsValue({
                    idDepartamentoPartida: { key: direccion.idDepartamento === 0 ? undefined : direccion.idDepartamento },
                    idProvinciaPartida: { key: direccion.idProvincia === 0 ? undefined : direccion.idProvincia },
                    idDistritoPartida: { key: direccion.idUbigeo === 0 ? undefined : direccion.idUbigeo }
                });
            });
        }


        if (property === "idEstablecimiento" || property === "idListaPrecio" || property === "idAlmacen") {

            var data = form.getFieldValue(property);
            var label = property === "idEstablecimiento" ? "el establecimiento" : property === "idListaPrecio" ? 'la lista de precio' : 'el almacén';
            if (this.state.formValues.listaComprobanteDetalle.length > 0) {
                dialog.confirm(<span>Al cambiar {label} se removera los productos agregados previamente.<br /><span>¿Deseas continuar?'</span></span>,
                    async () => {
                        if (property === "idEstablecimiento") {
                            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
                            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
                            const listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === value);
                            this.setState({
                                formValues: {
                                    ...this.state.formValues,
                                    almacenLoading: false,
                                    almacenes: almacenes ? almacenes : [],
                                    listasPrecio: listasPrecio ? listasPrecio : [],
                                }
                            });
                            form.setFieldsValue({
                                idAlmacen: undefined,
                                idListaPrecio: undefined
                            });
                        }

                        this.setState({
                            formValues: {
                                ...this.state.formValues,
                                listaComprobanteDetalle: []
                            }
                        });
                        form.setFieldsValue({
                            sumaTotalDetalle: 0,
                            sumaImporteDescuento: 0,
                            sumaSubTotal: 0,
                            sumaIgv: 0,
                            sumaIsc: 0,
                            sumaTotal: 0,
                            totalPeso: 0,
                            porcentajeDetraccion: 0,
                            importeDetraccion: 0,
                            totalDetraccion: 0,
                            porcentajePercepcion: 0,
                            importePercepcion: 0,
                            totalPercepcion: 0
                        });
                    }, () => form.setFieldsValue({
                        [property]: data
                    }));
            } else {
                if (property === "idEstablecimiento") {
                    this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
                    const almacenes = await almacenService.listarPorIdEstablecimiento(value);
                    const listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === value);
                    this.setState({
                        formValues: {
                            ...this.state.formValues,
                            almacenLoading: false,
                            almacenes: almacenes ? almacenes : [],
                            listasPrecio: listasPrecio ? listasPrecio : [],
                        }
                    });
                    form.setFieldsValue({
                        idAlmacen: undefined,
                        idListaPrecio: undefined,
                    });
                }
            }
        }
        debugger
        if (property == "idConcepto") {

            if ([3, 4, 5, 6].includes(value)) {
                await this.handleBuscarCliente(auth.user().ruc, form);
            }
            if (value == 5) {

                this.setState({
                    ...this.state.formValues,
                    idConcepto: value,
                    direccionLlegada: "-",
                    vehiculos: this.state.vehiculos

                })
                form.setFieldsValue({
                    idConcepto: value,
                    direccionLlegada: "-",

                });
            } else {

                this.setState({
                    ...this.state.formValues,
                    idConcepto: value,
                    idEstablecimientoDestino: undefined,
                    vehiculos: this.state.vehiculos,
                    flagEditDestinoCliente: value == 3 ? true : false,
                    direccionesPartidas: this.state.direccionesPartidas

                    //direccionLlegada: null
                })
                form.setFieldsValue({
                    idConcepto: value,
                    idEstablecimientoDestino: undefined,
                    flagEditDestinoCliente: value == 3 ? true : false,

                    //direccionLlegada: null
                });

            }

        }


        if (property === "idETransporte") {

            const trans = this.state.etransportes.filter(m => m.id == value);
            const mtc = trans.length > 0 ? trans[0].mtc : null;

            const vehiculos = this.state.vehiculos.filter(m => m.idTransporte === value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idVehiculo: undefined,
                    //licencia: null,
                    mtc: mtc,
                    vehiculos: vehiculos ? vehiculos : []
                }
            });
        }

        if (property === "idVehiculo") {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idVehiculo: value,
                    vehiculosSecundarios: []
                }
            });

            form.setFieldsValue({
                vehiculosSecundarios: []
            });
        }


        if (property === "idModalidadTraslado") {
            const vehiculos = this.state.vehiculos.filter(m => m.idModalidadTraslado === value);


            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idModalidadTraslado: value,
                    vehiculos: vehiculos ? vehiculos : [],
                }
            });

        }


        if (property === "idChofer") {
            const vehiculos = this.state.vehiculos.filter(m => m.idModalidadTraslado === PRIVADO);
            const chofer = this.state.choferes.filter(m => m.id == value);
            const licencia = chofer.length > 0 ? chofer[0].licencia : null;

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idVehiculo: undefined,
                    licencia: licencia,
                    //vehiculos: vehiculos ? vehiculos : [],
                    //tuc: '',
                    //mtc: '',
                    choferesSecundarios: []
                }
            });
            form.setFieldsValue({
                tuc: '',
                choferesSecundarios: []
            });
        }

        if (property === "idEstablecimientoDestino") {

            const direccion = await establecimientoService.obtenerPorId(value);
            const provinciasPartida = await ubigeoService.provincias(direccion.idDepartamento);
            const distritosPartida = await ubigeoService.distritos(direccion.idProvincia);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provinciasLlegada: provinciasPartida ? provinciasPartida : [],
                    distritosLlegada: distritosPartida ? distritosPartida : [],
                }
            }, () => {

                form.setFieldsValue({
                    idDepartamentoLlegada: { key: direccion.idDepartamento === 0 ? undefined : direccion.idDepartamento },
                    idProvinciaLlegada: { key: direccion.idProvincia === 0 ? undefined : direccion.idProvincia },
                    idDistritoLlegada: { key: direccion.idUbigeo === 0 ? undefined : direccion.idUbigeo }
                });
            });
        }

        if (property === "idDepartamentoPartida") {
            const provincias = await ubigeoService.provincias(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provinciasPartida: provincias
                }
            });
        }
        if (property === "idProvinciaPartida") {
            const _distritos = await ubigeoService.distritos(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    distritosPartida: _distritos
                }
            });
        }
        if (property === "idDepartamentoLlegada") {

            const provincias = await ubigeoService.provincias(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    provinciasLlegada: provincias
                }
            });
        }
        if (property === "idProvinciaLlegada") {

            const _distritos = await ubigeoService.distritos(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    distritosLlegada: _distritos
                }
            });
        }

        if (property === "direcciones-clear") {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idCliente: undefined,
                    documentoCliente: "",
                    direccionLlegada: "",
                    idDepartamentoLlegada: undefined,
                    idProvinciaLlegada: undefined,
                    idDistritoLlegada: undefined,
                    provinciasLlegada: [],
                    distritosLlegada: [],
                    direccionesPartidas: this.state.direccionesPartidas,
                    direcciones: [],
                }
            });

        }
        if (property === "direcciones-clear-provv") {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    idProveedor: undefined,
                    documentoProveedor: "",
                    idEstablecimientoProveedor: undefined,
                    documentoProveedor: "",
                }
            })
        }
    }

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            idProyecto: 0,
            idMoneda: SOLES, //..........................................................OK
            idEntidad: 0, //..........................................................OK
            idVendedor: 0,
            idEstablecimientoCliente: 0,
            idEstablecimiento: 0,
            idTipoGuia: 0,
            idVehiculo: 0,
            idAlmacen: 0, //..........................................................OK
            idModalidadTraslado: PRIVADO,
            flagTransportePrivado: true,
            idChofer: 0,
            idConcepto: 0,
            idListaPrecio: 0, //..........................................................OK
            idMotivo: 0,
            idMovimiento: 0,
            idETransporte: 0,
            idUsuarioRegistro: auth.user().id,
            idEstablecimientoPartida: 0,
            idEstablecimientoDestino: 0,
            flagGuiaRemisionGeneraSalidas: false,
            idDepartamentoPartida: 0,
            idProvinciaPartida: 0,
            idDistritoPartida: 0,
            proyectos: [],
            idDepartamentoLlegada: 0,
            idProvinciaLlegada: 0,
            idDistritoLlegada: 0,
            giroNegocio: "",
            serie: "", //............................................... OK
            documento: "", //............................................... OK
            dam: "",
            serieDam: "",
            codigoDam: "",
            mtc: "",
            fechaStr: global.fetchCurrentDateStr(), //......................................... OK
            fechaTrasladoStr: global.fetchCurrentDateStr(), //......................................... OK
            fechaEntregaStr: global.fetchCurrentDateStr(), //......................................... OK

            flagCategoria: false,
            flagProgramado: false,
            flagVehiculoVacio: false,
            flagEmbalajeVacio: false,

            tipoCambio: 0, //..........................................................OK
            observacion: "", //..........................................................OK
            tuc: "",
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            bultos: 0,
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotal: 0,
            totalPeso: 0,
            almacenLoading: false,
            clienteLoading: false,
            flagGiroNegocio: false,
            activeKey: "1",
            direccionPartida: "",
            direccionLlegada: "",
            idProveedor: 0,
            documentoProveedor: '',
            entidades: [],
            direccionesPartidas: [],
            direccionesLlegadas: [],
            unidadesMedida: [],
            direcciones: [],
            departamentosPartida: [],
            provinciasPartida: [],
            distritosPartida: [],
            tiposComprobante: [],
            departamentosLlegada: [],
            provinciasLlegada: [],
            distritosLlegada: [],
            clientes: [],
            vendedores: [],
            sucursales: [],
            tiposGuia: [],
            vehiculos: [],
            almacenes: [],
            traslados: [],
            choferes: [],
            listasPrecio: [],
            motivos: [],
            transportes: [],
            proveedores: [],
            numeroContenedor: '',
            codigoPuerto: '',
            numeroDocumentoEntidad: '',
            flagDestinatario: true,
            vehiculosSecundarios: [],
            choferesSecundarios: [],
            contenedores: [],
        }
    }

    fetchEmptyResetFormValues = () => {
        return {
            id: 0,
            idProyecto: 0,
            idMoneda: SOLES, //..........................................................OK
            idEntidad: 0, //..........................................................OK
            idVendedor: 0,
            idEstablecimiento: 0,
            idTipoGuia: 0,
            idEstablecimientoCliente: 0,
            idVehiculo: 0,
            idAlmacen: 0, //..........................................................OK
            idModalidadTraslado: 0,
            idChofer: 0,
            idListaPrecio: 0, //..........................................................OK
            idMotivo: 0,
            idETransporte: 0,
            idUsuarioRegistro: auth.user().id,
            idEstablecimientoPartida: 0,
            idEstablecimientoDestino: 0,
            idDepartamentoPartida: 0,
            idProvinciaPartida: 0,
            idDistritoPartida: 0,
            idProveedor: 0,
            proyectos: [],
            idDepartamentoLlegada: 0,
            idProvinciaLlegada: 0,
            idDistritoLlegada: 0,
            bultos: 0,
            serie: "", //............................................... OK
            documento: "", //............................................... OK
            dam: "",
            serieDam: "",
            codigoDam: "",
            // fechaStr: global.fetchCurrentDateStr(), //......................................... OK
            tuc: "",
            tipoCambio: 0, //..........................................................OK
            observacion: "", //..........................................................OK
            mtc: "",

            flagCategoria: false,
            flagProgramado: false,
            flagVehiculoVacio: false,
            flagEmbalajeVacio: false,

            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],

            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotal: 0,
            totalPeso: 0,
            almacenLoading: false,
            clienteLoading: false,
            activeKey: "1",
            clientes: [],
            entidades: [],
            direccionesPartidas: [],
            direccionesLlegadas: [],
            direcciones: [],
            departamentosPartida: [],
            provinciasPartida: [],
            distritosPartida: [],
            direccionPartida: "",
            direccionLlegada: "",
            departamentosLlegada: [],
            provinciasLlegada: [],
            distritosLlegada: [],
            proveedores: [],
            unidadesMedida: [],
            vendedores: [],
            sucursales: [],
            tiposGuia: [],
            vehiculos: [],
            almacenes: [],
            traslados: [],
            choferes: [],
            listasPrecio: [],
            motivos: [],
            transportes: [],
            tiposComprobante: [],
            numeroContenedor: '',
            codigoPuerto: '',
            numeroDocumentoEntidad: '',
            vehiculosSecundarios: [],
            choferesSecundarios: [],
            contenedores: [],
        }
    }

    fetchEditFormValues = (data) => {
        return {
            id: data.guiaRemision.id,
            idProyecto: data.guiaRemision.idProyecto,
            idMoneda: data.guiaRemision.idMoneda, //..........................................................OK
            idCliente: data.guiaRemision.idCliente, //..........................................................OK
            idVendedor: data.guiaRemision.idVendedor,
            idMovimiento: data.guiaRemision.idMovimiento,
            idEstablecimiento: data.guiaRemision.idEstablecimiento,
            idEstablecimientoPartida: data.guiaRemision.idEstablecimientoPartida,
            idEstablecimientoDestino: data.guiaRemision.idEstablecimientoDestino,
            flagTransportePrivado: data.guiaRemision.idModalidadTraslado === PRIVADO ? true : false,
            idAlmacen: data.guiaRemision.idAlmacen, //..........................................................OK
            idModalidadTraslado: data.guiaRemision.idModalidadTraslado,
            idChofer: data.guiaRemision.idChofer,
            idListaPrecio: data.guiaRemision.idListaPrecio, //..........................................................OK
            idMotivo: data.guiaRemision.idMotivoTraslado,
            idConcepto: data.guiaRemision.idConcepto,
            idETransporte: data.guiaRemision.idTransporte,
            idVehiculo: data.guiaRemision.idVehiculo,
            idDepartamentoPartida: data.guiaRemision.idDepartamentoPartida,
            idProvinciaPartida: data.guiaRemision.idProvinciaPartida,
            idDistritoPartida: data.guiaRemision.idDistritoPartida,

            flagCategoria: data.guiaRemision.flagCategoria,
            flagProgramado: data.guiaRemision.flagProgramado,
            flagVehiculoVacio: data.guiaRemision.flagVehiculoVacio,
            flagEmbalajeVacio: data.guiaRemision.flagEmbalajeVacio,
            giroNegocio: data.guiaRemision.giroNegocio,
            idDepartamentoLlegada: data.guiaRemision.idDepartamentoLlegada,
            idProvinciaLlegada: data.guiaRemision.idProvinciaLlegada,
            idDistritoLlegada: data.guiaRemision.idDistritoLlegada,
            idEstablecimientoCliente: 0,
            direccionPartida: data.guiaRemision.direccionPartida,
            direccionLlegada: data.guiaRemision.direccionLlegada,
            placaVehiculo: data.guiaRemision.placaVehiculo,
            marcaVehiculo: data.guiaRemision.marcaVehiculo,
            modeloVehiculo: data.guiaRemision.modeloVehiculo,
            colorVehiculo: data.guiaRemision.colorVehiculo,
            serie: data.guiaRemision.serie, //............................................... OK
            documento: data.guiaRemision.documento, //............................................... OK
            tuc: data.guiaRemision.tuc,
            dam: data.guiaRemision.dam,
            serieDam: data.guiaRemision.serieDam,
            codigoDam: data.guiaRemision.codigoDam,

            fechaStr: data.guiaRemision.fechaStr, //......................................... OK
            fechaTrasladoStr: data.guiaRemision.fechaTrasladoStr,
            tipoCambio: data.guiaRemision.tipoCambio, //..........................................................OK
            observacion: data.guiaRemision.observacion, //..........................................................OK
            descripcion: data.guiaRemision.descripcion,

            fechaEntregaStr: data.guiaRemision.fechaEntregaStr,
            bultos: data.guiaRemision.bultos,
            idProveedor: data.guiaRemision.idProveedor,
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            contenedores: [],
            idTercero: data.guiaRemision.idTercero,
            flagDestinatario: data.guiaRemision.flagDestinatario,

            sumaSubTotal: data.guiaRemision.precioSubTotal,
            sumaIgv: data.guiaRemision.precioIGV,
            sumaTotal: data.guiaRemision.precioTotal,
            totalPeso: data.guiaRemision.totalPeso,
            totalPesoCarga: data.guiaRemision.totalPesoCarga,

            almacenLoading: false,
            clienteLoading: false,
            activeKey: "1",
            unidadesMedida: [],
            entidades: [],
            clientes: [],
            direccionesPartidas: [],
            direccionesLlegadas: [],
            proyectos: [],
            departamentosPartida: [],
            provinciasPartida: [],
            distritosPartida: [],
            direcciones: [],
            departamentosLlegada: [],
            provinciasLlegada: [],
            distritosLlegada: [],
            proveedores: [],
            vendedores: [],
            sucursales: [],
            tiposGuia: [],
            vehiculos: [],
            almacenes: [],
            traslados: [],
            choferes: [],
            listasPrecio: [],
            motivos: [],
            transportes: [],
            vehiculosSecundarios: [],
            choferesSecundarios: [],

            documentoCliente: data.guiaRemision.numeroDocumentoEntidad,
            razonSocialEntidad: data.guiaRemision.razonSocialEntidad,
            documentoProveedor: '',

            numeroContenedor: data.guiaRemision.numeroContenedor,
            codigoPuerto: data.guiaRemision.codigoPuerto,
            moneda: data.guiaRemision.moneda,
            direccionPartida: data.guiaRemision.direccionPartida,
            direccionLlegada: data.guiaRemision.direccionLlegada,
            vendedor: data.guiaRemision.vendedor,
            sucursal: data.guiaRemision.sucursal,
            almacen: data.guiaRemision.almacen,
            listaPrecio: data.guiaRemision.listaPrecio,
            tipoGuia: data.guiaRemision.tipoGuia,
            traslado: data.guiaRemision.traslado,
            motivoTraslado: data.guiaRemision.motivoTraslado,
            vehiculo: data.guiaRemision.vehiculo,
            chofer: data.guiaRemision.chofer,
            licencia: data.guiaRemision.licencia,

            transporte: data.guiaRemision.transporte,

            departamentoPartida: data.guiaRemision.nombreDepartamentoPartida,
            provinciaPartida: data.guiaRemision.nombreProvinciaPartida,
            distritoPartida: data.guiaRemision.nombreDistritoPartida,

            departamentoLlegada: data.guiaRemision.nombreDepartamentoLlegada,
            provinciaLlegada: data.guiaRemision.nombreProvinciaLlegada,
            distritoLlegada: data.guiaRemision.nombreDistritoLlegada,
        }
    }



    handleNew = async () => {

        var params = auth.user().parametros;
        var paramGuiaRemisionGeneraSalidas = params.filter((m) => m.abreviatura === VENTA_GUIA_REMISION_GENERA_SALIDAS)[0].valor === "1"
            ? true
            : false;

        var controlDcumento = params.filter((m) => m.abreviatura === CONTROL_COMPBANTE)[0].valor === "1" ? true : false;
        if (controlDcumento) {
            if (this.state.totaldocument[0].total > auth.user().totalDocumentos) {
                message.error('Usted no puede crear comprobantes. ya supero la cantidad contratada');
                return;
            }
        }

        var flagEditCode = this.state.configuraciones.filter((m) => m.abreviatura === EDIT_COD_GUIA).length >= 1 ? true : false;


        var formValues = this.fetchEmptyFormValues();
        formValues.flagGuiaRemisionGeneraSalidas = paramGuiaRemisionGeneraSalidas;
        formValues.direccionesPartidas = this.state.direccionesPartidas;
        formValues.vendedores = this.state.vendedores;
        formValues.clientes = this.state.clientes;
        formValues.sucursales = this.state.sucursales;
        formValues.almacenes = this.state.almacenes;
        formValues.proveedores = this.state.proveedores;
        formValues.proyectos = this.state.proyectos;
        formValues.tiposGuia = this.state.tiposGuia.filter(m => (m.id === 10 || m.id === 32));;
        formValues.traslados = this.state.traslados;
        formValues.motivos = this.state.motivos;

        formValues.vehiculos = this.state.vehiculos.filter(m => m.idModalidadTraslado === PRIVADO);
        formValues.choferes = this.state.choferes;
        formValues.transportes = this.state.etransportes;
        formValues.unidadesMedida = this.state.unidadesMedida;
        formValues.flagGiroNegocio = this.state.company.idTipoEmpresa == 4 ? true : false;

        formValues.tiposComprobante = this.state.tiposComprobante;
        var partida = formValues.direccionesPartidas[0];
        formValues.direccionPartida = partida.direccion;
        formValues.idEstablecimientoPartida = partida.id;
        formValues.idListaPrecio = formValues.listasPrecio.length === 0 ? 0 : formValues.listasPrecio[0].id;
        formValues.flagEditCode = flagEditCode;

        const _ubigeo = this.state.ubigeos.filter(m => m.id === partida.idUbigeo)[0];
        const _ubigeoDep = this.state.ubigeos.filter(m => m.codigo === '0000' + _ubigeo.codigo.substring(0, 2))[0];
        const _ubigeoProv = this.state.ubigeos.filter(m => m.codigo === '00' + _ubigeo.codigo.substring(0, 4))[0];

        const departamentos = await ubigeoService.departamentos()
        const provincias = await ubigeoService.provincias(_ubigeoDep.id);
        const distritos = await ubigeoService.distritos(_ubigeoProv.id);

        formValues.departamentosPartida = departamentos;
        formValues.departamentosLlegada = departamentos;
        formValues.provinciasPartida = provincias;
        formValues.distritosPartida = distritos;
        formValues.idDepartamentoPartida = _ubigeoDep.id; // departamentos.filter(m => m.codigo === '0000' + _ubigeo.codigo.substring(0, 2))[0].id;
        formValues.idProvinciaPartida = _ubigeoProv.id; // provincias.filter(m => m.codigo === '00' + _ubigeo.codigo.substring(0, 4))[0].id;
        formValues.idDistritoPartida = partida.idUbigeo; // distritos.filter(m => m.codigo === _ubigeo.codigo)[0].id;


        const datosIniciales = await guiaRemisionService.datosIniciales({ idUsuario: auth.user().id, idTipoComprobante: GUIA_REMISION_REMITENTE.ID });
        if (datosIniciales !== undefined) {
            formValues.serie = datosIniciales.serie;
            formValues.idVendedor = datosIniciales.idVendedor;
            formValues.idAlmacen = datosIniciales.idAlmacen;
            formValues.idEstablecimiento = datosIniciales.idEstablecimiento;
            formValues.idListaPrecio = datosIniciales.idListaPrecio;
        }

        if (formValues.idEstablecimiento > 0) {
            const almacenes = await await almacenService.listarPorIdEstablecimiento(formValues.idEstablecimiento);
            const listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === formValues.idEstablecimiento);
            formValues.almacenes = almacenes ? almacenes : [];
            formValues.listasPrecio = listasPrecio ? listasPrecio : [];
        }


        // var productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);

        // var searchComprobantesFilter = {
        //     IdTipoComprobante: 0,
        //     FechaInicioStr: '',
        //     FechaFinStr: '',
        //     Serie: '',
        //     Documento: ''
        // };
        // var _comprobantes = await comprobanteService.listarTodos(searchComprobantesFilter); 

        if (formValues.serie == "" || formValues.serie == null) {
            setTimeout(() => {
                dialog.error("Tiene que registrar serie correlativo para poder emitir el documento");

            }, 100);

        } else {

            this.setState({
                visible: true,
                // comprobantes: _comprobantes.data ? _comprobantes.data : [],
                formValues,
                // productos: productos ? productos : []
            });
        }


    }

    handleOnChangeEntidad = async (form) => {
        // console.log(value);
        var numberDocument = form.getFieldValue("documentoCliente");

        this.setState({
            formValues: {
                ...this.state.formValues,
                documentoCliente: numberDocument,
                direccionesLlegadas: []
            }
        });

        var _cliente = this.state.formValues.clientes.filter(e => e.numeroDocumento == numberDocument);

        const direccionesEstablecimientos = await establecimientoService.listarPorIdEntidad(_cliente[0].idEntidad);

        if (direccionesEstablecimientos === undefined) {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direccionesLlegadas: [],
                    numberDocument: ''
                }
            });
        } else {

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    direccionesLlegadas: direccionesEstablecimientos
                }
            });

            if (direccionesEstablecimientos.length === 1) {
                var llegada = direccionesEstablecimientos[0];
                const _ubigeo = this.state.ubigeos.filter(m => m.id === llegada.idUbigeo)[0];
                const _ubigeoDep = this.state.ubigeos.filter(m => m.codigo === '0000' + _ubigeo.codigo.substring(0, 2))[0];
                const _ubigeoProv = this.state.ubigeos.filter(m => m.codigo === '00' + _ubigeo.codigo.substring(0, 4))[0];

                const departamentos = await ubigeoService.departamentos()
                const provincias = await ubigeoService.provincias(_ubigeoDep.id);
                const distritos = await ubigeoService.distritos(_ubigeoProv.id);

                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        idDireccionLlegada: llegada.id,
                        departamentosLlegada: departamentos,
                        provinciasLlegada: provincias,
                        distritosLlegada: distritos,
                        idDepartamentoLlegada: _ubigeoDep.id,
                        idProvinciaLlegada: _ubigeoProv.id,
                        idDistritoLlegada: llegada.idUbigeo
                    }
                });
            }
        }
    }

    handleChangeTab = (key) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key
            }
        });
    };


    handleBuscarProveedor = async (value, form) => {
        this.setState({
            formValues: { ...this.state.formValues, proveedorLoading: true },
        });

        //const response = await padronReducidoService.logistica_proveedor(value);

        var numberDocument = form.getFieldValue("documentoProveedor");
        if (numberDocument == "" || numberDocument == "null" || numberDocument == "undefined") {
            dialog.warning(<ul>Ingrese documento valido</ul>);

            return;
        }

        var response = numberDocument.length == 8 ? await padronReducidoService.obtenerProveedorDniApi(value) :
            await padronReducidoService.obtenerProveedorRucApi(value);
        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
            this.setState({ formValues: { ...this.state.formValues, proveedorLoading: false } });

            return;
        }

        if (response.status === 200) {

            const direcciones = response.data.direcciones;
            const direccionPrincipal = direcciones.length > 0 ? direcciones[0] : undefined;
            const provinciasPartida = await ubigeoService.provincias(direccionPrincipal.idDepartamento);
            const distritosPartida = await ubigeoService.distritos(direccionPrincipal.idProvincia);

            this.setState(
                {
                    formValues: {
                        ...this.state.formValues,
                        proveedorLoading: false,

                        provinciasPartida: provinciasPartida ? provinciasPartida : [],
                        distritosPartida: distritosPartida ? distritosPartida : [],
                        idEstablecimientoPartida: direccionPrincipal.id,
                        direccionesPartidas: direcciones,
                        direccionPartida: direccionPrincipal.direccion,
                    },
                },
                () => {

                    /*           form.setFieldsValue({
                                  proveedores: response.data.proveedores,
                                  idProveedor: response.data.proveedores.length > 0 ? { key: response.data.proveedores[0].id } : undefined,
                                  idEstablecimientoProveedor: response.data.direcciones.length > 0 ? { key: response.data.direcciones[0].id } : undefined,
                                  direccionProveedor: response.data.direcciones.length > 0 ? response.data.direcciones[0].direccion : ""
                              }); */

                    form.setFieldsValue({
                        proveedores: response.data.proveedores,
                        idProveedor: response.data.proveedores.length > 0 ? { key: response.data.proveedores[0].id } : undefined,

                        direccionPartida: direccionPrincipal.direccion,
                        idEstablecimientoPartida: { key: direccionPrincipal.id === 0 ? undefined : direccionPrincipal.id },
                        idDepartamentoPartida: direccionPrincipal.idDepartamento > 0 ? { key: direccionPrincipal.idDepartamento } : undefined,
                        idProvinciaPartida: direccionPrincipal.idProvincia > 0 ? { key: direccionPrincipal.idProvincia } : undefined,
                        idDistritoPartida: direccionPrincipal.idUbigeo > 0 ? { key: direccionPrincipal.idUbigeo } : undefined,
                    });

                }
            );
        } else {
            this.setState(
                {
                    formValues: {
                        ...this.state.formValues,
                        proveedorLoading: false,
                        direcciones: [],
                    },
                },
                () => {
                    form.setFieldsValue({
                        proveedores: [],
                        idProveedor: undefined,
                        idEstablecimientoProveedor: undefined,
                    });
                }
            );
        }
    };

    handleAgregarDetalle = (onSetFieldsValue, onGetFieldValue) => {

        this.setState({
            onSetFieldsValue,
            onGetFieldValue
        }, () => {
            if (this.state.formValues.activeKey === "1")
                this.handleOpenSearchProductModal();

            if (this.state.formValues.activeKey === "2")
                this.handleAddReferencia();
            if (this.state.formValues.activeKey === "3")
                this.handleAddVehiculo();

            if (this.state.formValues.activeKey === "4")
                this.handleAddChofer();

            if (this.state.formValues.activeKey === "5")
                this.handleAddContenedor();
        });
    };


    handleAddContenedor = () => {
        var contenedores = this.state.onGetFieldValue('contenedores');

        if (contenedores.length == 2) {
            dialog.warning("Solo se permiten agregar 2 contenedores");
            return;
        }
        contenedores.push({
            identifier: global.fetchUniqueCode(),
            numero: "",
            precinto: ""
        });

        this.setState({
            formValues: {
                ...this.state.formValues,
                contenedores: contenedores
            }
        });

        this.state.onSetFieldsValue({ contenedores });
    };

    handleAddChofer = () => {
        var choferesSecundarios = this.state.onGetFieldValue('choferesSecundarios');

        choferesSecundarios.push({
            identifier: global.fetchUniqueCode(),
            idChofer: 0,
            licencia: ""
        });

        this.setState({
            formValues: {
                ...this.state.formValues,
                choferesSecundarios: choferesSecundarios
            }
        });

        this.state.onSetFieldsValue({ choferesSecundarios });
    };

    handleRemoverChofer = (item, form) => {


        this.setState({
            formValues: {
                ...this.state.formValues,
                choferesSecundarios: this.state.formValues.choferesSecundarios.filter(m => m.identifier !== item.identifier)
            },
        }, () => {
            var arrDetalle = form.getFieldValue('choferesSecundarios');
            form.setFieldsValue({
                choferesSecundarios: arrDetalle.filter(m => m.identifier !== item.identifier)
            });
        });
    };


    handleRemoverContenedor = (item, form) => {


        this.setState({
            formValues: {
                ...this.state.formValues,
                contenedores: this.state.formValues.contenedores.filter(m => m.identifier !== item.identifier)
            },
        }, () => {
            var arrDetalle = form.getFieldValue('contenedores');
            form.setFieldsValue({
                contenedores: arrDetalle.filter(m => m.identifier !== item.identifier)
            });
        });
    };

    handleAddVehiculo = () => {
        var vehiculosSecundarios = this.state.onGetFieldValue('vehiculosSecundarios');
        vehiculosSecundarios.push({
            identifier: global.fetchUniqueCode(),
            placa: "",
            idVehiculo: 0,
            tuc: "",
        });

        this.setState({
            formValues: {
                ...this.state.formValues,
                vehiculosSecundarios: vehiculosSecundarios
            }
        });

        this.state.onSetFieldsValue({ vehiculosSecundarios });
    };

    handleRemoverVehiculo = (item, form) => {

        this.setState({
            formValues: {
                ...this.state.formValues,
                vehiculosSecundarios: this.state.formValues.vehiculosSecundarios.filter(m => m.identifier !== item.identifier)
            },
        });
    };

    handleAddReferencia = () => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

        listaComprobanteReferencia.push({
            identifier: global.fetchUniqueCode(),
            idReferencia: 0,
            idReferenciaOrigen: 0,
            idTipoComprobante: 0,
            series: "",
            documentos: "",
            flagInterno: true
        });

        referenciaCount = referenciaCount + 1;

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            }
        });
    };

    handleRemoverReferencia = (item) => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia.filter(m => m.identifier !== item.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            }
        });
    };

    handleOpenSearchProductModal = async () => {
        /*    var idAlmacen = this.state.onGetFieldValue('idAlmacen');
           var idListaPrecio = this.state.onGetFieldValue('idListaPrecio');
   
           if (idAlmacen === undefined || idAlmacen.key === 0) {
               message.warning('Por favor seleccione un almacén.');
               return;
           }
   
           if (idListaPrecio === undefined || idListaPrecio.key === 0) {
               message.warning('Por favor seleccione una lista de precio.');
               return;
           } */

        var filter = {
            idAlmacen: 0,
            idListaPrecio: 0,
            idMoneda: 1,
            IdSistema: 2
        }
        var response = await productoService.Sinstock(filter);

        this.setState({
            searchProductVisible: true,
            searchProductFormValues: {
                ...this.state.searchProductFormValues,
                validarStock: response.validarStock,
                dataSource: response.productos.filter(m => m.idTipoProducto !== SERVICIO)
            }
        });
    };

    handleBuscarProducto = async (value) => {


        var filter = {
            idAlmacen: 0,
            idListaPrecio: 0,
            idMoneda: 1,
            idSistema: LOGISTICA,
            codigoNombre: value
        }

        const response = await productoService.Sinstock(filter);
        this.setState({
            searchProductVisible: true,
            searchProductFormValues: {
                ...this.state.searchProductFormValues,
                validarStock: response.validarStock,
                dataSource: response.productos
            }
        });
    };

    handleSelectProduct = (row) => {

        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;
        var listEmpty = this.state.formValues.listaComprobanteDetalle.length;

        var item = {
            identifier: global.fetchUniqueCode(),
            idProducto: row.id,
            codigo: row.codigoReferencia,
            nombre: row.nombre,
            nombreUnidadMedida: row.nombreUnidadMedida,
            idUnidadMedida: row.idUnidadMedida,
            flagAfecto: row.flagIGVAfecto,
            flagGratuito: row.flagGratuito,
            flagExonerado: row.flagExonerado,
            cantidad: 0,
            dam: "",
            pesoUnitario: row.pesoUnitario,
            totalPeso: 0,
            fechaVencimiento: '',
            numeroLote: row.numeroLote,
            stock: row.stockDisponible,
            flagConversion: false,

        };

        listaComprobanteDetalle.push(item);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle
            }
        }, () => {
            var producto = {
                identifier: item.identifier,
                idProducto: item.idProducto,
                codigo: item.codigoReferencia,
                nombre: item.nombre,
                numeroLote: item.numeroLote,
                idUnidadMedida: row.idUnidadMedida,
                cantidad: item.cantidad,
                pesoUnitario: item.pesoUnitario,
                totalPeso: item.totalPeso,
                flagAfecto: item.flagAfecto,
                flagGratuito: item.flagGratuito,
                flagExonerado: item.flagExonerado,
                subTotal: 0,
                igv: 0,
                pesoUnitario: 0,
                flagConversion: false,
            };

            var arrDetalle = this.state.onGetFieldValue('arrDetalle');
            if (listEmpty === 0) {
                arrDetalle = [];
            }
            arrDetalle.push(producto);
            this.state.onSetFieldsValue({ arrDetalle });
        }
        );
    };


    handleScanerProduct = async (value, onSetFieldsValue, onGetFieldValue) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue,
        });
        // dialog.confirm(
        //   "El total de la venta excede el monto máximo establecido ¿Desea continuar?",
        //   async () => {

        var idAlmacen = this.state.onGetFieldValue('idAlmacen');

        if (idAlmacen === undefined) {
            message.warning('Por favor seleccione un almacén.');
            return;
        }

        /* PARAMETROS */
        /* LSITA */
        var listaComprobanteDetalle = this.state.formValues
            .listaComprobanteDetalle;
        var filter_detalle = listaComprobanteDetalle.filter(
            (m) => m.codigoBarra === value
        );

        var item = {};
        if (filter_detalle.length > 0) {
            listaComprobanteDetalle = listaComprobanteDetalle.filter(
                (m) => m.codigoBarra !== value
            );
            var item = filter_detalle[0];
            item.cantidad = item.cantidad + 1;
        } else {
            var filter = {
                idAlmacen: idAlmacen.key,
                idSistema: LOGISTICA,
                codigoNombre: value
            };

            var list = await productoService.stock(filter);
            var filter_list = list.productos.filter(
                (m) => m.codigoBarra === value
            );
            if (filter_list.length === 0) {
                alert("no existe el producto");
                return;
            }
            var row = filter_list[0];

            var item = {
                identifier: global.fetchUniqueCode(),
                idProducto: row.id,
                codigo: row.codigoReferencia,
                codigoBarra: row.codigoBarra,
                nombre: row.nombre,
                nombreUnidadMedida: row.nombreUnidadMedida,
                flagAfecto: row.flagIGVAfecto,
                cantidad: 1,
                pesoUnitario: row.pesoUnitario,
                totalPeso: row.pesoUnitario,
                fechaVencimiento: '',
                numeroLote: row.numeroLote,
                stock: row.stockDisponible
            };
        }

        /* CALCULOS */
        item.totalPeso = item.cantidad * item.pesoUnitario;
        /* CALCULOS */

        listaComprobanteDetalle.push(item);

        this.setState(
            {
                formValues: {
                    ...this.state.formValues,
                    listaComprobanteDetalle: listaComprobanteDetalle,
                },
            },
            () => {

                var producto = {
                    identifier: item.identifier,
                    idProducto: item.idProducto,
                    numeroLote: item.numeroLote,
                    cantidad: item.cantidad,
                    pesoUnitario: item.pesoUnitario,
                    totalPeso: item.totalPeso,
                    flagAfecto: item.flagAfecto,
                    subTotal: item.subTotal,
                    igv: item.igv,
                    pesoUnitario: item.pesoUnitario
                };


                var arrDetalle = this.state.onGetFieldValue(
                    "arrDetalle"
                );
                arrDetalle = arrDetalle.filter(
                    (m) => m.identifier !== producto.identifier
                );
                arrDetalle.push(producto);
                this.state.onSetFieldsValue({
                    totalPeso: listaComprobanteDetalle.reduce(
                        (a, b) => a + (b["totalPeso"] || 0),
                        0
                    ),
                    arrDetalle: arrDetalle
                });
            }
        );
        //   }
        // );
    };


    handleRemoverProducto = (row, form) => {

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier !== row.identifier)
            },
        }, () => {
            var arrDetalle = form.getFieldValue('arrDetalle');
            form.setFieldsValue({
                arrDetalle: arrDetalle.filter(m => m.identifier !== row.identifier)
            });
        });
    };
    handleSave = async (values, form) => {
        var envioAutomatico = this.state.configuraciones.filter((m) => m.abreviatura === EMI_GUIA_AUTO).length >= 1 ? true : false;

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {


            if (values.guiaRemisionDetalles !== undefined) {
                for (var i = 0; i < values.guiaRemisionDetalles.length; i++) {
                    var item = this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier === values.guiaRemisionDetalles[i].identifier)[0];
                    if (item !== null && item !== undefined) {
                        values.guiaRemisionDetalles[i].nombre = item.nombre;
                        values.guiaRemisionDetalles[i].codigoReferencia = item.codigo;

                    }
                }
            }

            var response;
            if (values.id === 0 || values.id === undefined)
                response = await guiaRemisionService.registrar(values);
            else
                response = await guiaRemisionService.modificar(values);

            if (response.status === 200) {
                var empty = this.fetchEmptyResetFormValues();
                this.setState({ visible: false, formValues: empty });
                form.setFieldsValue(empty);
                form.resetFields();

                if (values.id === 0)
                    message.success('Registrado correctamente.');
                else
                    message.success('Modificado correctamente.');

                this._handlePagination(this.state.filter);

                if (envioAutomatico) {
                    setTimeout(() => {
                        this.setState({ loadingEmitir: true, loadingEdit: true });
                        this.handleEnvioComprobantes(values.id === 0 ? response.data : values.id);

                    }, 1000);
                }

                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleEnvioComprobantes = async (data) => {

        var response = await guiaRemisionService.emitir({ id: data });

        if (response.status === 200) {
            dialog.success(response.data);
            this._handlePagination(this.state.filter);
            this.setState({ loadingEmitir: false });
            return;
        }

        if (response.status === 400) {
            dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
        }
        this._handlePagination(this.state.filter);
        this.setState({ loadingEmitir: false, loadingEdit: false });

    }
    handleSelectRowComprobante = async (row) => {

        const response = await comprobanteService.obtenerPorId(row.id);
        if (response !== undefined) {
            formValuesComprobante.productos = [];
            formValuesComprobante.listaComprobanteDetalle = [];
            formValuesComprobante.listaComprobanteReferencia = [];
            formValuesComprobante.idComprobante = row.id;

            for (let index = 0; index < response.detalles.length; index++) {
                const element = response.detalles[index];
                formValuesComprobante.productos.push(element.idProducto);
            }

            formValuesComprobante.listaComprobanteDetalle = response.detalles;
            formValuesComprobante.listaComprobanteReferencia = response.referencias;

            this.setState({
                importarComprobanteModalVisible: true,
                importarComprobanteModal: {
                    ...this.state.importarComprobanteModal,
                    dataSourceDetalle: response.detalles
                }
            })


        }
    }

    handleOkImportarComprobante = async (values, form) => {

        for (let index = 0; index < formValuesComprobante.listaComprobanteDetalle.length; index++) {
            const row = formValuesComprobante.listaComprobanteDetalle[index];
            var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;
            var item = {
                identifier: global.fetchUniqueCode(),
                idProducto: row.idProducto,
                codigo: row.codigoReferencia,
                nombre: row.nombre,
                nombreUnidadMedida: row.nombreUnidadMedida,
                flagAfecto: row.flagAfecto,
                cantidad: row.cantidad,
                subTotal: row.subTotal,
                igv: row.igv,
                total: row.total,
                pesoUnitario: 0,
                fechaVencimiento: '',
                numeroLote: row.numeroLote
            };

            listaComprobanteDetalle.push(item);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    listaComprobanteDetalle: listaComprobanteDetalle
                }
            });
        }

        for (let index = 0; index < formValuesComprobante.listaComprobanteReferencia.length; index++) {
            const element = formValuesComprobante.listaComprobanteReferencia[index];

            var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

            listaComprobanteReferencia.push({
                identifier: referenciaCount,
                idReferencia: formValuesComprobante.idComprobante,
                idReferenciaOrigen: 1,
                idTipoComprobante: element.idTipoComprobante,
                serie: element.serie,
                documento: element.documento,
                flagInterno: true
            });

            referenciaCount = referenciaCount + 1;

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    listaComprobanteReferencia: listaComprobanteReferencia
                }
            });
        }

        if (formValuesComprobante.idComprobante !== null && formValuesComprobante.idComprobante > 0) {
            const responseComprobante = await comprobanteService.obtenerPorId(formValuesComprobante.idComprobante);
            const listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;
            listaComprobanteReferencia.push({
                identifier: referenciaCount,
                idReferencia: formValuesComprobante.idComprobante,
                idReferenciaOrigen: 1,
                idTipoComprobante: responseComprobante.idTipoComprobante,
                serie: responseComprobante.serie,
                documento: responseComprobante.documento,
                flagInterno: true
            });
            referenciaCount = referenciaCount + 1;

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    listaComprobanteReferencia: listaComprobanteReferencia
                }
            });
        }

        this.setState({
            importarComprobanteModalVisible: false,
            formValues: {
                ...this.state.formValues,
                idComprobante: formValuesComprobante.idComprobante
            }
        });


    }

    setGridProductos = (data) => {
        const arrDetalle = [];
        data.guiaRemisionDetalles.forEach(element => {
            var oneProd = {
                identifier: global.fetchUniqueCode(),
                idProducto: element.idProducto,
                codigo: element.codigoReferencia,
                nombre: element.nombre,
                dam: element.dam,
                nombreUnidadMedida: element.nombreUnidadMedida,
                numeroLote: element.numeroLote,
                cantidad: element.cantidad,
                pesoUnitario: element.pesoUnitario,
                totalPeso: element.totalPeso,
                idUnidadMedida: element.idUnidadMedida,
                flagConversion: element.flagConversion,
            }
            arrDetalle.push(oneProd);
        });
        return arrDetalle;
    }

    setGridProductosDetalle = (data) => {
        const arrDetalle = [];

        data.forEach(element => {
            var oneProd = {
                identifier: element.identifier,
                idProducto: element.idProducto,
                numeroLote: element.numeroLote,
                dam: element.dam,
                cantidad: element.cantidad,
                pesoUnitario: element.pesoUnitario,
                totalPeso: element.totalPeso,
                flagAfecto: element.flagAfecto,
                subTotal: 0,
                igv: 0,
                idUnidadMedida: element.idUnidadMedida,
                flagConversion: element.flagConversion,
            };


            arrDetalle.push(oneProd);
        });
        return arrDetalle;
    }

    setGridReferencias = (data) => {
        const detalleReferencias = [];
        data.guiaRemisionReferencias.forEach((element, index) => {
            var oneRef = {
                identifier: referenciaCount,
                idReferencia: element.id,
                idReferenciaOrigen: element.idReferenciaOrigen,
                idTipoComprobante: element.idTipoComprobante,
                serie: element.serie,
                documento: element.documento,
                flagInterno: true,
                nombreTipoComprobante: element.nombreTipoComprobante
            }
            referenciaCount = referenciaCount + 1;

            detalleReferencias.push(oneRef);
        });

        return detalleReferencias;
    }

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await guiaRemisionService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Guia Remesion.xlsx");
    };

    handleExportPdf = async () => {
        this.setState({ loadingImprimir: true });
        var response = await guiaRemisionService.pdf(this.state.filter);
        this.setState({ loadingImprimir: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Guia Remesion.pdf");
    };

    handleVer = async (values) => {
        const response = await guiaRemisionService.obtenerPorId(values.id);
        if (response !== undefined) {
            var formValues = this.fetchEditFormValues(response);
            formValues.tiposComprobante = this.state.tiposComprobante;

            formValues.proyectos = this.state.proyectos;
            formValues.listaComprobanteDetalle = this.setGridProductos(response);
            formValues.listaComprobanteReferencia = this.setGridReferencias(response);
            formValues.contenedores = response.guiaRemision.jsonContenedor ? JSON.parse(response.guiaRemision.jsonContenedor) : [];

            this.setState({
                visibleVer: true,
                formValues
            });
        }
    }

    handleEdit = async (values) => {
        this.setState({ loadingEdit: true });

        const response = await guiaRemisionService.obtenerPorId(values.id);
        if (response !== undefined) {

            var params = auth.user().parametros;
            var paramGuiaRemisionGeneraSalidas =
                params.filter(
                    (m) => m.abreviatura === VENTA_GUIA_REMISION_GENERA_SALIDAS
                )[0].valor === "1"
                    ? true
                    : false;
            var flagEditCode = this.state.configuraciones.filter((m) => m.abreviatura === EDIT_COD_GUIA).length >= 1 ? true : false;

            var formValues = this.fetchEditFormValues(response);
            formValues.listaComprobanteDetalle = this.setGridProductos(response);
            formValues.listaComprobanteReferencia = this.setGridReferencias(response);
            formValues.flagGuiaRemisionGeneraSalidas = paramGuiaRemisionGeneraSalidas;
            formValues.direccionesPartidas = this.state.direccionesPartidas;
            formValues.vendedores = this.state.vendedores;
            formValues.sucursales = this.state.sucursales;
            formValues.proyectos = this.state.proyectos;
            formValues.flagGiroNegocio = this.state.company.idTipoEmpresa == 4 ? true : false;
            formValues.contenedores = response.guiaRemision.jsonContenedor ? JSON.parse(response.guiaRemision.jsonContenedor) : [];
            formValues.flagEditCode = flagEditCode;

            formValues.unidadesMedida = this.state.unidadesMedida;
            var codigoMotivo = this.state.motivos.filter(m => (m.id == formValues.idMotivo));

            formValues.codigoMotivo = codigoMotivo.length > 0 ? codigoMotivo[0].codigoSunat : '01';

            if (formValues.codigoMotivo == "04") {
                formValues.direccionesLlegadas = this.state.direccionesPartidas;
            }

            response.guiaRemisionVehiculos.forEach((element, index) => {
                var oneRef = {
                    identifier: global.fetchUniqueCode(),
                    placa: element.placa,
                    tuc: element.tuc,
                    idVehiculo: element.idVehiculo,
                    flagInterno: true,
                }
                formValues.vehiculosSecundarios.push(oneRef);
            });

            response.guiaRemisionChoferes.forEach((element, index) => {
                var oneRef = {
                    identifier: global.fetchUniqueCode(),
                    idChofer: element.idChofer,
                    nombres: element.nombres,
                    licencia: element.licencia,
                    flagInterno: true,
                }
                formValues.choferesSecundarios.push(oneRef);
            });

            //this.state.almacenes;
            formValues.listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === formValues.idEstablecimiento);
            formValues.tiposGuia = this.state.tiposGuia.filter(m => (m.id === 10 || m.id === 32));
            formValues.traslados = this.state.traslados;
            formValues.motivos = this.state.motivos;
            formValues.choferes = this.state.choferes;
            formValues.clientes = this.state.clientes;
            formValues.transportes = this.state.etransportes;
            formValues.tiposComprobante = this.state.tiposComprobante;
            formValues.proveedores = this.state.proveedores;
            if (formValues.idModalidadTraslado === PRIVADO) {
                const vehiculos = this.state.vehiculos.filter(m => m.idModalidadTraslado === PRIVADO);
                formValues.vehiculos = vehiculos;
            } else {
                const vehiculos = this.state.vehiculos.filter(m => m.idTransporte === formValues.idETransporte);
                formValues.vehiculos = vehiculos;
            }
            if (formValues.idProveedor > 0) {

                var _provv = this.state.proveedores.filter(e => e.id == formValues.idProveedor);

                const direcciones = await establecimientoService.listarPorIdEntidad(_provv[0].idEntidad);
                formValues.direccionesPartidas = direcciones;
                formValues.documentoProveedor = _provv.length > 0 ? _provv[0].numeroDocumento : null;

            }

            if (formValues.idTercero > 0) {

                var _provv = this.state.clientes.filter(e => e.id == formValues.idTercero);
                const direcciones = await establecimientoService.listarPorIdEntidad(_provv[0].idEntidad);
                formValues.direccionesPartidas = direcciones;
                formValues.documentoTercero = _provv.length > 0 ? _provv[0].numeroDocumento : null;
                formValues.direccionesLlegadas = this.state.direccionesPartidas;

            }


            const departamentosPartida = await ubigeoService.departamentos()
            const provinciasPartida = await ubigeoService.provincias(formValues.idDepartamentoPartida);
            const distritosPartida = await ubigeoService.distritos(formValues.idProvinciaPartida);

            const departamentosLlegada = await ubigeoService.departamentos()
            const provinciasLlegada = await ubigeoService.provincias(formValues.idDepartamentoLlegada);
            const distritosLlegada = await ubigeoService.distritos(formValues.idProvinciaLlegada);

            //const almacenes = await await almacenService.listarPorIdEstablecimiento(formValues.idEstablecimiento);


            //formValues.almacenes = almacenes;
            formValues.departamentosPartida = departamentosPartida;
            formValues.departamentosLlegada = departamentosLlegada;

            formValues.provinciasPartida = provinciasPartida;
            formValues.provinciasLlegada = provinciasLlegada;

            formValues.distritosPartida = distritosPartida;
            formValues.distritosLlegada = distritosLlegada;

            var productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);


            /*            var searchComprobantesFilter = {
                           IdTipoComprobante: 0,
                           FechaInicioStr: '',
                           FechaFinStr: '',
                           Serie: '',
                           Documento: ''
                       };
                       var _comprobantes = await comprobanteService.listarTodos(searchComprobantesFilter); */

            this.setState({
                visible: true,
                loadingEdit: false,
                //comprobantes: _comprobantes,
                formValues,
                productos: productos ? productos : [],
                prodsArrDetalle: this.setGridProductosDetalle(formValues.listaComprobanteDetalle)
            });
        }
    }

    handleAnular = async (values) => {
        dialog.confirm("Esta acción solo indicara que la Guía de Remisión seleccionada esta inutilizada para un control interno, esta no será anulada en la SUNAT", async () => {
            var response = await guiaRemisionService.eliminar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    }

    handleCopy = async (values) => {
        this.setState({ loadingEdit: true });

        const response = await guiaRemisionService.obtenerPorId(values.id);
        if (response !== undefined) {

            var params = auth.user().parametros;
            var paramGuiaRemisionGeneraSalidas = params.filter((m) => m.abreviatura === VENTA_GUIA_REMISION_GENERA_SALIDAS)[0].valor === "1"
                ? true
                : false;
            var flagEditCode = this.state.configuraciones.filter((m) => m.abreviatura === EDIT_COD_GUIA).length >= 1 ? true : false;

            var formValues = this.fetchEditFormValues(response);
            formValues.listaComprobanteDetalle = this.setGridProductos(response);
            formValues.listaComprobanteReferencia = this.setGridReferencias(response);
            formValues.flagGuiaRemisionGeneraSalidas = paramGuiaRemisionGeneraSalidas;
            formValues.direccionesPartidas = this.state.direccionesPartidas;
            formValues.vendedores = this.state.vendedores;
            formValues.sucursales = this.state.sucursales;
            formValues.proyectos = this.state.proyectos;
            formValues.flagGiroNegocio = this.state.company.idTipoEmpresa == 4 ? true : false;
            formValues.flagEditCode = flagEditCode;
            formValues.id = 0;

            formValues.unidadesMedida = this.state.unidadesMedida;
            var codigoMotivo = this.state.motivos.filter(m => (m.id == formValues.idMotivo));

            formValues.codigoMotivo = codigoMotivo.length > 0 ? codigoMotivo[0].codigoSunat : '01';

            if (formValues.codigoMotivo == "04") {
                formValues.direccionesLlegadas = this.state.direccionesPartidas;
            }

            response.guiaRemisionVehiculos.forEach((element, index) => {
                var oneRef = {
                    identifier: global.fetchUniqueCode(),
                    placa: element.placa,
                    tuc: element.tuc,
                    idVehiculo: element.idVehiculo,
                    flagInterno: true,
                }
                formValues.vehiculosSecundarios.push(oneRef);
            });

            response.guiaRemisionChoferes.forEach((element, index) => {
                var oneRef = {
                    identifier: global.fetchUniqueCode(),
                    idChofer: element.idChofer,
                    nombres: element.nombres,
                    licencia: element.licencia,
                    flagInterno: true,
                }
                formValues.choferesSecundarios.push(oneRef);
            });

            //this.state.almacenes;
            formValues.listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === formValues.idEstablecimiento);
            formValues.tiposGuia = this.state.tiposGuia.filter(m => (m.id === 10 || m.id === 32));
            formValues.traslados = this.state.traslados;
            formValues.motivos = this.state.motivos;
            formValues.choferes = this.state.choferes;
            formValues.clientes = this.state.clientes;
            formValues.transportes = this.state.etransportes;
            formValues.tiposComprobante = this.state.tiposComprobante;
            formValues.proveedores = this.state.proveedores;
            if (formValues.idModalidadTraslado === PRIVADO) {
                const vehiculos = this.state.vehiculos.filter(m => m.idModalidadTraslado === PRIVADO);
                formValues.vehiculos = vehiculos;
            } else {
                const vehiculos = this.state.vehiculos.filter(m => m.idTransporte === formValues.idETransporte);
                formValues.vehiculos = vehiculos;
            }
            if (formValues.idProveedor > 0) {

                var _provv = this.state.proveedores.filter(e => e.id == formValues.idProveedor);

                const direcciones = await establecimientoService.listarPorIdEntidad(_provv[0].idEntidad);
                formValues.direccionesPartidas = direcciones;
                formValues.documentoProveedor = _provv.length > 0 ? _provv[0].numeroDocumento : null;

            }

            if (formValues.idTercero > 0) {

                var _provv = this.state.clientes.filter(e => e.id == formValues.idTercero);
                const direcciones = await establecimientoService.listarPorIdEntidad(_provv[0].idEntidad);
                formValues.direccionesPartidas = direcciones;
                formValues.documentoTercero = _provv.length > 0 ? _provv[0].numeroDocumento : null;
                formValues.direccionesLlegadas = this.state.direccionesPartidas;

            }


            const departamentosPartida = await ubigeoService.departamentos()
            const provinciasPartida = await ubigeoService.provincias(formValues.idDepartamentoPartida);
            const distritosPartida = await ubigeoService.distritos(formValues.idProvinciaPartida);

            const departamentosLlegada = await ubigeoService.departamentos()
            const provinciasLlegada = await ubigeoService.provincias(formValues.idDepartamentoLlegada);
            const distritosLlegada = await ubigeoService.distritos(formValues.idProvinciaLlegada);

            //const almacenes = await await almacenService.listarPorIdEstablecimiento(formValues.idEstablecimiento);


            //formValues.almacenes = almacenes;
            formValues.departamentosPartida = departamentosPartida;
            formValues.departamentosLlegada = departamentosLlegada;

            formValues.provinciasPartida = provinciasPartida;
            formValues.provinciasLlegada = provinciasLlegada;

            formValues.distritosPartida = distritosPartida;
            formValues.distritosLlegada = distritosLlegada;

            var productos = await productoService.listarPorIdListaPrecio(formValues.idListaPrecio);


            this.setState({
                visible: true,
                loadingEdit: false,
                //comprobantes: _comprobantes,
                formValues,
                productos: productos ? productos : [],
                prodsArrDetalle: this.setGridProductosDetalle(formValues.listaComprobanteDetalle)
            });
        }
    }


    handleBuscarCliente = async (value, form) => {
        this.setState({ formValues: { ...this.state.formValues, clienteLoading: true } });

        //const response = await padronReducidoService.boleta(value);
        var numberDocument = form.getFieldValue("documentoCliente") == undefined ? value : form.getFieldValue("documentoCliente");
        if (numberDocument == "" || numberDocument == "null" || numberDocument == undefined) {
            dialog.warning(<ul>Ingrese documento valido</ul>);

            return;
        }
        const length = numberDocument.trim().length;

        if ([8, 11].includes(length)) {

            var response = length == 8 ? await padronReducidoService.obtenerDniApi(value) :
                await padronReducidoService.obtenerRucApi(value);

            if (response.status === 200) {
                const provinciasLlegada = await ubigeoService.provincias(response.data.direcciones[0].idDepartamento);
                const distritosLlegada = await ubigeoService.distritos(response.data.direcciones[0].idProvincia);

                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        clienteLoading: false,
                        direccionesLlegadas: response.data.direcciones,
                        documentoCliente: response.data.numeroDocumento,
                        provinciasLlegada: provinciasLlegada,
                        distritosLlegada: distritosLlegada,
                        direcciones: response.data.direcciones,
                        direccionLlegada: response.data.direcciones[0].direccion,
                    }
                }, () => {
                    form.setFieldsValue({
                        clientes: response.data.clientes,
                        documentoCliente: response.data.numeroDocumento,
                        idCliente: response.data.clientes.length > 0 ? { key: response.data.clientes[0].id } : undefined,
                        idEstablecimientoCliente: response.data.direcciones.length > 0 && response.data.direcciones[0].id ? { key: response.data.direcciones[0].id } : undefined,
                        idDepartamentoLlegada: response.data.direcciones.length > 0 && response.data.direcciones[0].idDepartamento != 0 ? { key: response.data.direcciones[0].idDepartamento } : undefined,
                        idProvinciaLlegada: response.data.direcciones.length > 0 && response.data.direcciones[0].idProvincia != 0 ? { key: response.data.direcciones[0].idProvincia } : undefined,
                        idDistritoLlegada: response.data.direcciones.length > 0 && response.data.direcciones[0].idUbigeo != 0 ? { key: response.data.direcciones[0].idUbigeo } : undefined
                    });
                });
            }
            else {
                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        clienteLoading: false,
                        direcciones: [],
                    }
                }, () => {
                    form.setFieldsValue({
                        clientes: [],
                        idProvinciaLlegada: undefined,
                        idDepartamentoLlegada: undefined,
                        idUbigeo: undefined,
                        idCliente: undefined,
                        idEstablecimientoCliente: undefined
                    });
                });
            }
        } else {
            dialog.warning(<ul>Solo Acepta DNI / RUC</ul>);

        }



    };

    handleChangeNameProduct = (row) => {
        var flagEditCode = this.state.configuraciones.filter((m) => m.abreviatura === EDIT_COD_GUIA).length >= 1 ? true : false;

        this.setState({
            renombrarProductoVisible: true,
            renombrarProductoModal: {
                ...this.state.renombrarProductoModal,
                nombre: row.nombre,
                idProducto: row.idProducto,
                identifier: row.identifier,
                codigo: row.codigo,
                flagEditCode: auth.user().planCode == "PLA001" ? flagEditCode : false,

            }
        })
    }

    handleOkChangeNameProduct = (value, form) => {

        var listaComprobanteDetalle_aux = this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier !== value.identifier);
        var currentRow = this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier === value.identifier)[0];
        var currentRowIndex = this.state.formValues.listaComprobanteDetalle.findIndex(m => m.identifier === value.identifier);
        currentRow.nombre = value.nombre;
        currentRow.codigo = value.codigo;

        // listaComprobanteDetalle_aux.push(currentRow);
        listaComprobanteDetalle_aux.splice(currentRowIndex, 0, currentRow);

        var empty_renombrarProductoModal = {
            nombre: '',
            idProducto: 0,
            identifier: '',
            codigo: ''
        };

        form.setFieldsValue(empty_renombrarProductoModal);
        form.resetFields();
        this.setState({
            renombrarProductoVisible: false,
            renombrarProductoModal: {
                ...this.state.renombrarProductoModal,
                nombre: '',
                idProducto: 0,
                identifier: '',
                codigo: ''
            },
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle_aux,

            }
        });
    }

    handleImprimir = async (item) => {

        this.setState({ loadingImprimir: true });

        var file = undefined;
        var response = undefined;
        var idFormato = this.state.company.formatoPrint;
        var isEpson = JSON.parse(localStorage.getItem("isEpson"));
        if (idFormato === 1) {
            response = await guiaRemisionService.pdfA4({ id: item.id });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await guiaRemisionService.ticket({
                id: item.id,
                isEpson: isEpson == null ? false : isEpson
            });
            file = window.URL.createObjectURL(response.data);
        }
        if (idFormato === 3) {
            response = await guiaRemisionService.ticket50({ id: item.id });
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            imprimirVisible: true,
            loadingImprimir: false,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                file,
                fileName: item.serie + '-' + item.documento,
                idGuiaRemision: item.id,
                idFormato: idFormato,
                isEpson: isEpson == undefined ? false : isEpson

            }
        });
    };


    handleDownloadPdf = async () => {

        /*     var response = undefined;
            var file = undefined;
    
            response = await guiaRemisionService.pdfA4({
                id: this.state.imprimirFormValues.idGuiaRemision,
              });
              file = window.URL.createObjectURL(response.data);
    
              
            
        
            if (this.state.imprimirFormValues.idFormato === 1) {
              response = await guiaRemisionService.pdfA4({
                id: this.state.imprimirFormValues.idGuiaRemision,
              });
              file = window.URL.createObjectURL(response.data);
            }
         if (this.state.imprimirFormValues.idFormato === 2) {
              response = await notaVentaService.ticket({
                id: this.state.imprimirFormValues.idComprobante,
              });
              file = window.URL.createObjectURL(response.data);
            }
        
            if (this.state.imprimirFormValues.idFormato === 3) {
              response = await notaVentaService.ticket50({
                id: this.state.imprimirFormValues.idComprobante,
              });
              file = window.URL.createObjectURL(response.data);
            } 
        
            if (response !== undefined)
              global.dowloadFile(
                response.data,
                this.state.imprimirFormValues.fileName + ".pdf"
              ); */
        global.downloadFileBlob(this.state.imprimirFormValues.file, this.state.imprimirFormValues.fileName + ".pdf");

    };
    handleSwitch = async (e) => {
        localStorage.setItem("isEpson", JSON.stringify(e))
        this.setState({
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                isEpson: e,
            }
        })

        setTimeout(() => {
            this.handleChangeImprimir(2)
        }, 100);
    }
    handleChangeImprimir = async (idFormato) => {
        var file = undefined;
        var response = undefined;
        if (idFormato === 1) {
            response = await guiaRemisionService.pdfA4({ id: this.state.imprimirFormValues.idGuiaRemision });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {

            response = await guiaRemisionService.ticket({
                id: this.state.imprimirFormValues.idGuiaRemision,
                isEpson: JSON.parse(localStorage.getItem("isEpson")),
            });
            file = window.URL.createObjectURL(response.data);
        }
        if (idFormato === 3) {
            response = await guiaRemisionService.ticket50({ id: this.state.imprimirFormValues.idGuiaRemision });
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            imprimirVisible: true,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                file,
                idFormato,
                isEpson: JSON.parse(localStorage.getItem("isEpson")),

            }
        });
    };


    handleCorreo = async (item) => {
        this.setState({
            loadingCorreo: false,
            correoVisible: true,
            correoFormValues: {
                ...this.state.correoFormValues,
                idComprobante: item.id,
                idFormato: 1, // A4
                correoCliente: item.correoCliente
            }
        });
    };

    handleEnviarCorreo = async (data, form) => {
        dialog.confirm('¿Desea enviar el correo?', async () => {
            var response = await guiaRemisionService.enviarCorreo(data);

            if (response.status === 200) {
                form.resetFields();
                dialog.success('El correo ha sido enviado.');
                this.setState({ correoVisible: false });
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };
    handleImportarComprobante = async (onSetFieldsValue, onGetFieldValue) => {

        this.setState({
            onSetFieldsValue,
            onGetFieldValue
        }, async () => {
            var idCliente = this.state.onGetFieldValue('idCliente');

            if (idCliente === undefined || idCliente.key === 0) {
                message.warning('Por favor busque y/o seleccione un cliente.');
                return;
            }

            var filter = {
                idCliente: idCliente.key,
                serie: '',
                documento: '',
            }

            var response = await comprobanteService.importarRegistradosEmitidos(filter);

            this.setState({
                importarComprobanteVisible: true,
                importarFormValues: {
                    dataSource: response
                }
            });
        });
    };

    handleSelectComprobante = async (row) => {

        var response = await comprobanteService.obtenerPorId(row.id);

        if (response === undefined) {
            dialog.error("Ocurrió un error mientras se obtenia los datos.");
            return;
        }

        var productos = [];
        var listaComprobanteDetalle = [];
        var listaComprobanteReferencia = [];

        response.detalles.forEach(element => {
            const identifier = global.fetchUniqueCode();

            listaComprobanteDetalle.push({
                identifier: identifier,
                idProducto: element.idProducto,
                codigo: element.codigoReferencia,
                nombre: element.nombre,
                numeroLote: element.numeroLote,
                nombreUnidadMedida: element.nombreUnidadMedida,
                idUnidadMedida: element.idUnidadMedida,
                flagAfecto: element.flagAfecto,
                cantidad: element.cantidad,
                pesoUnitario: element.pesoUnitario,
                totalPeso: element.totalPeso,
                flagConversion: element.flagConversion,

            });

            productos.push({
                identifier: identifier,
                idProducto: element.idProducto,
                codigo: element.codigoReferencia,
                nombre: element.nombre,
                numeroLote: element.numeroLote,
                nombreUnidadMedida: element.nombreUnidadMedida,
                idUnidadMedida: element.idUnidadMedida,
                flagAfecto: element.flagAfecto,
                cantidad: element.cantidad,
                pesoUnitario: element.pesoUnitario,
                totalPeso: element.totalPeso,
                flagConversion: element.flagConversion,

            });
        });

        const tipoComprobante = this.state.tiposComprobante.filter(m => m.codigoSunat === response.tipoComprobante);
        if (tipoComprobante.length == 0) {
            dialog.info("Revisa el documento referencia");
        }

        listaComprobanteReferencia.push({
            identifier: referenciaCount,
            idReferencia: response.id,
            idReferenciaOrigen: 1,
            idTipoComprobante: tipoComprobante[0].id,
            serie: response.serie,
            documento: response.documento,
            flagInterno: true
        });


        const almacenes = await almacenService.listarPorIdEstablecimiento(response.idEstablecimiento);
        const listasPrecio = this.state.listasPrecio.filter(m => m.idEstablecimiento === response.idEstablecimiento);
        this.setState({
            formValues: {
                ...this.state.formValues,
                almacenes: almacenes,
                listasPrecio: listasPrecio,
                idEstablecimiento: response.idEstablecimiento,
                idAlmacen: response.idAlmacen,
                idMoneda: response.idMoneda,
                idProyecto: response.idProyecto,
                idListaPrecio: response.idListaPrecio,
                listaComprobanteDetalle: listaComprobanteDetalle,
                listaComprobanteReferencia: listaComprobanteReferencia,
                activeKey: "2"
            }
        }, () => {
            var detalleProductos = [];
            productos.forEach(producto => {
                detalleProductos.push(producto);
            });

            this.state.onSetFieldsValue({
                arrDetalle: detalleProductos,
                arrReferencia: listaComprobanteReferencia,
                idEstablecimiento: { key: response.idEstablecimiento },
                idAlmacen: { key: response.idAlmacen },
                idProyecto: { key: response.idProyecto },
                idMoneda: { key: response.idMoneda },
                idListaPrecio: { key: response.idListaPrecio },
                idTipoComprobanteImportado: response.idTipoComprobante,
                totalPeso: response.totalPeso,
            });
        });
    };

    handleOpenEmitirModal = async (item) => {
        this.setState({ loadingEmitir: true });

        this.handleEmitir(item);

    };


    handleEmitir = async (item) => {
        item = this.state.emitirVisible ? this.state.selectedItem : item;

        dialog.confirm("¿Desea enviar la guía de remisión a sunat " + item.serieDocumento + " ?", async () => {

            var response = await guiaRemisionService.emitir({ id: item.id });

            this.setState({ loadingEmitir: false });

            if (response.status === 200) {
                //form.resetFields();
                dialog.success(response.data);
                this._handlePagination(this.state.filter);
                this.setState({ emitirVisible: false });
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li>{item}</li>))}</ul>);
                return;
            }
            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        }, async () => { this.setState({ loadingEmitir: false }) });
    };


    handleDownloadXml = async () => {

        var response = await guiaRemisionService.xml({ id: this.state.selectedItem.id });
        if (response !== undefined)
            global.dowloadFile(response.data, this.state.selectedItem.nombreXML);
    };

    handleDownloadCdr = async () => {
        var response = await guiaRemisionService.cdr({ id: this.state.selectedItem.id });
        if (response !== undefined)
            global.dowloadFile(response.data, this.state.selectedItem.nombreCDR);
    };

    handleOpenCdrModal = async (row) => {

        this.setState({
            cdrVisible: true,
            selectedItem: row
        });
    };

    handleImportarCotizacion = async (onSetFieldsValue, onGetFieldValue) => {
        this.setState(
            {
                onSetFieldsValue,
                onGetFieldValue,
            },
            async () => {
                var idCliente = this.state.onGetFieldValue("idCliente");
                var idMoneda = this.state.onGetFieldValue("idMoneda");

                var filter = {
                    idCliente: idCliente === undefined ? 0 : idCliente.key,
                    serie: "",
                    documento: "",
                    idMoneda: idMoneda === undefined ? 0 : idMoneda.key,

                };


                if (idCliente === undefined) {
                    dialog.error("Debe seleccionar un Cliente");
                    return;
                } else {

                    var response = await cotizacionService.importarRegistrados(filter);

                    this.setState({
                        importarCotizacionVisible: true,
                        importarCotizacionFormValues: {
                            ...this.state.importarCotizacionFormValues,
                            dataSource: response,
                            selectedRowKeys: this.state.formValues.listaComprobanteReferencia.map(function (v) {
                                return v.serie + '-' + v.documento;
                            })
                        },
                    });
                }



            }
        );
    };

    handleSelectCotizacion = async (selected, row, form) => {

        var response = undefined;
        var productos = this.state.onGetFieldValue("arrDetalle");

        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;
        var obj = {};
        var totalPeso = 0;

        if (row.length == 0) {

            listaComprobanteDetalle = listaComprobanteDetalle.filter(e => e.importado == true);
            listaComprobanteReferencia = listaComprobanteReferencia.filter(e => e.importado == true);
            productos = productos.filter(e => e.importado == true);

            if (listaComprobanteReferencia.length > 0)
                totalPeso = parseFloat(listaComprobanteDetalle.reduce((a, b) => a + (b["total"] || 0), 0));


            setTimeout(() => {
                this.setState({
                    formValues: {
                        ...this.state.formValues,
                        listaComprobanteDetalle,
                        listaComprobanteReferencia
                    },
                    importarCotizacionFormValues: {
                        ...this.state.importarCotizacionFormValues,
                        selectedRowKeys: selected
                    }
                })

                this.state.onSetFieldsValue({

                    detalleProductos: productos,
                });
            }, 100)
        }
        if (row.length == 1) {

            listaComprobanteDetalle = listaComprobanteDetalle.filter(e => e.importado == true);
            listaComprobanteReferencia = listaComprobanteReferencia.filter(e => e.importado == true);
            productos = productos.filter(e => e.importado == true);

            if (listaComprobanteReferencia.length > 0)
                totalPeso = parseFloat(listaComprobanteDetalle.reduce((a, b) => a + (b["total"] || 0), 0));

            response = await cotizacionService.obtenerPorId(row[0].id);

            response.cotizacionDetalles.forEach(element => {
                const identifier = global.fetchUniqueCode();
                var itemsConversion = [];

                var item = {
                    identifier: global.fetchUniqueCode(),
                    idProducto: element.idProducto,
                    codigo: element.codigoReferencia,
                    nombre: element.nombre,
                    nombreUnidadMedida: element.nombreUnidadMedida,
                    idUnidadMedida: element.idUnidadMedida,
                    flagAfecto: element.flagAfecto,
                    flagGratuito: element.flagGratuito,
                    flagExonerado: element.flagExonerado,
                    cantidad: element.cantidad,
                    dam: "",
                    pesoUnitario: 0,
                    totalPeso: 0,
                    fechaVencimiento: '',
                    numeroLote: element.numeroLote,
                    stock: 0,
                    flagConversion: false,

                };

                listaComprobanteDetalle.push(item);


                productos.push(item);



            });

            listaComprobanteReferencia.push({
                identifier: global.fetchUniqueCode(),
                idReferencia: response.cotizacion.id,
                flagInterno: true,
                idReferenciaOrigen: VENTAS_COTIZACION,
                idTipoComprobante: 28, // COTIZACION GUIA VENTAS_COTIZACION
                serie: response.cotizacion.serie,
                documento: response.cotizacion.documento,
                importado: false,
            });

            listaComprobanteReferencia = listaComprobanteReferencia.filter(m => selected.filter(f => f === m.serie + '-' + m.documento).length);

            this.SelectCotizacion(response, listaComprobanteDetalle, productos, listaComprobanteReferencia, selected, obj);

        }

        var contador = 0;
        if (row.length > 1) {

            listaComprobanteDetalle = listaComprobanteDetalle.filter(e => e.importado == true);
            listaComprobanteReferencia = listaComprobanteReferencia.filter(e => e.importado == true);
            productos = productos.filter(e => e.importado == true);

            if (listaComprobanteReferencia.length > 0)
                totalPeso = parseFloat(listaComprobanteDetalle.reduce((a, b) => a + (b["total"] || 0), 0));

            row.forEach(async (item) => {

                response = await cotizacionService.obtenerPorId(item.id);

                response.cotizacionDetalles.forEach(element => {
                    const identifier = global.fetchUniqueCode();
                    var itemsConversion = [];
                    var item = {
                        identifier: global.fetchUniqueCode(),
                        idProducto: element.idProducto,
                        codigo: element.codigoReferencia,
                        nombre: element.nombre,
                        nombreUnidadMedida: element.nombreUnidadMedida,
                        idUnidadMedida: element.idUnidadMedida,
                        flagAfecto: element.flagAfecto,
                        flagGratuito: element.flagGratuito,
                        flagExonerado: element.flagExonerado,
                        cantidad: element.cantidad,
                        dam: "",
                        pesoUnitario: 0,
                        totalPeso: 0,
                        fechaVencimiento: '',
                        numeroLote: element.numeroLote,
                        stock: 0,
                        flagConversion: false,

                    };


                    listaComprobanteDetalle.push(item);


                    productos.push(item);

                });

                listaComprobanteReferencia.push({
                    identifier: global.fetchUniqueCode(),
                    idReferencia: response.cotizacion.id,
                    flagInterno: true,
                    idReferenciaOrigen: VENTAS_COTIZACION,
                    idTipoComprobante: 28, // COTIZACION GUIA VENTAS_COTIZACION
                    serie: response.cotizacion.serie,
                    documento: response.cotizacion.documento,
                    importado: false,
                });


                contador++;

                if (contador == row.length) {
                    listaComprobanteReferencia = listaComprobanteReferencia.filter(m => selected.filter(f => f === m.serie + '-' + m.documento).length);


                    this.SelectCotizacion(response, listaComprobanteDetalle, productos, listaComprobanteReferencia, selected, obj);

                }
            })

        }

        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: "2",
            }
        })

    };

    SelectCotizacion = async (response, listaComprobanteDetalle, productos, listaComprobanteReferencia, selected, obj) => {

        var formValues = {
            ...this.state.formValues,
            listaComprobanteDetalle: listaComprobanteDetalle,
            listaComprobanteReferencia: listaComprobanteReferencia,
            isImportando: true,
            activeKey: "1",
            observacion: response.cotizacion.observacion,


        };


        this.setState({
            direcciones: formValues.direcciones,
            formValues: formValues,
            importarCotizacionFormValues: {
                ...this.state.importarCotizacionFormValues,
                selectedRowKeys: selected
            }
        }, () => {
            var detalleProductos = [];
            productos.forEach(producto => {
                detalleProductos.push(producto);
            });

            this.state.onSetFieldsValue({

                idProyecto: { key: response.cotizacion.idProyecto == null ? 0 : response.cotizacion.idProyecto },
                arrDetalle: detalleProductos,
                idTipoComprobanteImportado: response.cotizacion.idTipoComprobante,

            });
        });
    }


    async componentDidMount() {
        var idUsuario = auth.user().id;

        const datosIniciales = await comprobanteService.datosIniciales({ idUsuario: idUsuario, idTipoComprobante: GUIA_REMISION_REMITENTE.ID });

        const configuraciones = await configuracionService.obtenerPorModulo({ idUsuario: idUsuario, idModulo: VENTA });
        var flagSerie = configuraciones.filter((m) => m.abreviatura === VER_SERIES_VENTA).length >= 1 ? true : false;
        const serie = [undefined, null].includes(datosIniciales?.serie) ? flagSerie ? '' : '-' : datosIniciales.serie;


        this.setState({ filter: { ...this.state.filter, serie } });

        this._initPagination(this.state.filter, guiaRemisionService.paginacion);

        const response = await guiaService.listar();

        const establecimientos = response.list_Establecimiento.result;
        const tiposComprobante = response.list_TipoComprobante.result;
        const vehiculos = response.list_Vehiculo.result;
        const choferes = response.list_Chofer.result;
        const traslados = response.list_Modalidad.result;
        const tiposGuia = response.list_TipoComprobante.result;
        const transportes = response.list_Transporte.result;
        const motivosTraslado = response.list_Motivo.result;
        const _ubigeos = response.list_Ubigeo.result;
        const clientes = response.list_Cliente.result;
        const estado = await guiaRemisionService.listarEstado();

        const unidadesMedida = response.list_UnidadMedida.result;
        const proveedores = response.list_Proveedor.result;
        const proyectos = response.list_Proyecto.result;

        const totaldocument = response.list_TotalComprobante.result;
        const company = response.list_Empresa;

        /*         const establecimientos = await establecimientoService.principales();
                const tiposComprobante = await tipoComprobanteService.listar();
                const vehiculos = await vehiculoService.listar();
                const choferes = await choferService.listar();
                const traslados = await modalidadTrasladoService.listar();
                const tiposGuia = await tipoComprobanteService.listar();
                const transportes = await transporteService.listar();
                const motivosTraslado = await motivoTrasladoService.listar();
                const _ubigeos = await ubigeoService.listar();
                const clientes = await clienteService.listar();
                const estado = await guiaRemisionService.listarEstado();
                const unidadesMedida = await unidadMedidaService.listarGRE();
                const proveedores = await proveedorService.listar();
                const proyectos = await proyectoService.listar(); */


        this.setState({
            loadingSource: false,
            direccionesPartidas: establecimientos ? establecimientos : [],
            vendedores: [],
            sucursales: establecimientos ? establecimientos : [],
            // almacenes: almacenes ? almacenes :[],
            listasPrecio: [],
            tiposGuia: tiposGuia ? tiposGuia : [],
            traslados: traslados ? traslados : [],
            motivos: motivosTraslado ? motivosTraslado : [],
            vehiculos: vehiculos ? vehiculos : [],
            choferes: choferes ? choferes : [],
            etransportes: transportes ? transportes : [],
            clientes: clientes ? clientes : [],
            proyectos: proyectos ? proyectos : [],
            tiposComprobante: tiposComprobante ? tiposComprobante.filter(e => e.flagGRER) : [],
            ubigeos: _ubigeos ? _ubigeos : [],
            estado: estado ? estado : [],
            unidadesMedida: unidadesMedida ? unidadesMedida : [],
            proveedores: proveedores ? proveedores : [],
            configuraciones: configuraciones ? configuraciones : [],
            totaldocument: totaldocument ? totaldocument : [],
            company: company

        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Guía de Remisión Remitente"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                    estado={this.state.estado}
                    motivo={this.state.motivos}
                    modalidad={this.state.traslados}
                    proyectos={this.state.proyectos}
                    configuraciones={this.state.configuraciones}


                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingEdit}
                    loadingSource={this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingCopy={this.state.loadingCopy || this.state.loadingSource}
                    loadingImprimir={this.state.loadingImprimir}
                    loadingCorreo={this.state.loadingCorreo}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onCorreo={this.handleCorreo}
                    onVer={this.handleVer}
                    onEditar={this.handleEdit}
                    onCopy={this.handleCopy}
                    onAnular={this.handleAnular}
                    onChange={this._handleChangePagination}
                    onImprimir={this.handleImprimir}
                    onEmitir={this.handleOpenEmitirModal}
                    onCdr={this.handleOpenCdrModal}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onBuscarProveedor={this.handleBuscarProveedor}
                    onBuscarCliente={this.handleBuscarCliente}
                    onChangeEntidad={this.handleOnChangeEntidad}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onRemoverProducto={this.handleRemoverProducto}
                    onImportarCotizacion={this.handleImportarCotizacion}
                    onRemoverReferencia={this.handleRemoverReferencia}
                    onRemoveVehiculo={this.handleRemoverVehiculo}
                    onRemoveChofer={this.handleRemoverChofer}
                    onRemoveContenedor={this.handleRemoverContenedor}
                    onChangeTab={this.handleChangeTab}
                    onChange={this.handleChangeForm}
                    onImportarComprobante={this.handleImportarComprobante}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onChangeNameProduct={this.handleChangeNameProduct}
                    arrDetalle={this.state.prodsArrDetalle}
                    onScanerProduct={this.handleScanerProduct}
                />
                <FormModalVer
                    visible={this.state.visibleVer}
                    formValues={this.state.formValues}
                    onChangeTab={this.handleChangeTab}
                    onClose={() => this.setState({ visibleVer: false })}
                />

                <SearchProductModal
                    onBuscarProducto={this.handleBuscarProducto}
                    visible={this.state.searchProductVisible}
                    validarStock={this.state.searchProductFormValues.validarStock}
                    dataSource={this.state.searchProductFormValues.dataSource}
                    dataSourceAgregado={this.state.formValues.listaComprobanteDetalle}
                    onSelect={this.handleSelectProduct}
                    idSistema={LOGISTICA}
                    onCancel={() => this.setState({ searchProductVisible: false })}
                />
                {/* <FormModalImportarComprobante
                    visible={this.state.importarComprobanteModalVisible}
                    formValues={this.state.importarComprobanteModal}
                    onCancel={() => this.setState({ importarComprobanteModalVisible: false })}
                    onChangeRow={this.handleSelectRowComprobante}
                    onHandleOkImportarComprobante={this.handleOkImportarComprobante}
                /> */}

                <ImportarModalCotizacion
                    tittle="Búsqueda de Cotización"
                    visible={this.state.importarCotizacionVisible}
                    formValues={this.state.importarCotizacionFormValues}
                    onSelect={this.handleSelectCotizacion}
                    onClose={() => this.setState({ importarCotizacionVisible: false })}
                />

                <RenombrarProductoModal
                    visible={this.state.renombrarProductoVisible}
                    formValues={this.state.renombrarProductoModal}
                    onCancel={() => this.setState({ renombrarProductoVisible: false })}
                    onSaveRename={this.handleOkChangeNameProduct}
                />
                <EmitirModal
                    visible={this.state.emitirVisible}
                    file={this.state.emitirFilePdf}
                    onEmitir={this.handleEmitir}
                    onClose={() => this.setState({ emitirVisible: false })}
                />
                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onDownload={this.handleDownloadPdf}
                    onSwitch={this.handleSwitch}

                    onClose={() => this.setState({ imprimirVisible: false })}
                />
                <ImportarModal
                    tittle="Búsqueda de Facturas / Boletas"
                    visible={this.state.importarComprobanteVisible}
                    formValues={this.state.importarFormValues}
                    dataSource={this.state.importarFormValues.dataSource}
                    onSelect={this.handleSelectComprobante}
                    onClose={() => this.setState({ importarComprobanteVisible: false })}
                />

                <CdrModal
                    visible={this.state.cdrVisible}
                    item={this.state.selectedItem}
                    onDownloadXml={this.handleDownloadXml}
                    onDownloadCdr={this.handleDownloadCdr}
                    onClose={() => this.setState({ cdrVisible: false })}
                />

                <CorreoModal
                    visible={this.state.correoVisible}
                    formValues={this.state.correoFormValues}
                    onChange={this.handleChangeCorreo}
                    onClose={() => this.setState({ correoVisible: false })}
                    onSend={this.handleEnviarCorreo}
                />
            </div>
        )
    }

}